<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="cancel"
    :transition-appear="true"
  >
    <div @click="cancel" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <h1 style="color: #000; font-weight: bold">
        {{ $t('login.login').toUpperCase() }}<br /><br />
      </h1>
      <div style="height: 0.22rem"></div>
      <van-form class="flex column center">
        <InputField
          v-model="username"
          :placeholder="$t('register.username-tip')"
          style="margin-bottom: 0.2rem; font-size: 0.28rem"
          :isPhone="true"
          :maxlength="10"
          from="login"
          type="number"
          :focus="usernameFocus"
          :enter="
            () => {
              passwordFocus = true
            }
          "
        />
      </van-form>
      <van-form class="flex column center" style="margin-bottom: -0.1rem">
        <InputField
          v-model="password"
          :placeholder="$t('register.password-tip')"
          style="font-size: 0.28rem"
          type="password"
          :focus="passwordFocus"
          :enter="
            (value) => {
              password = value
              passwordFocus = false
              onLogin()
            }
          "
        />
      </van-form>
      <a @click="onForget" class="forget">{{ $t('login.forget') }}</a>
      <div class="submit" @click="onLogin">{{ $t('login.login') }}</div>
      <a class="sign-up" v-html="$t('login.active-signup')" @click="onOpenRegister"></a>
      <div style="height: 1.35rem"></div>
      <!-- <div class="popup_footer" @click="onChat">
        {{ $t('register.service') }} -->
      <!-- </div> -->
    </div>
  </van-popup>
</template>

<script>
import { AIRBRIDEG_EVENT, airbrideg_report } from '@/common/airbridge'
import { removeLocalStorage } from '@/common/localStorage'
import InputField from '@/components/active/ActiveInputField.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import SocketService from '@/server/socket'
import { useUserStore } from '@/stores/user'
import { mapActions, mapState } from 'pinia'
import { closeToast, showLoadingToast, showSuccessToast } from 'vant'
export default {
  name: 'LobbyLogin',
  components: { InputField },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showValue: false,
      username: '',
      password: '',
      usernameFocus: true,
      passwordFocus: false
    }
  },
  watch: {
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
    }
  },
  computed: {
    ...mapState(useUserStore, ['country'])
  },
  mounted() {
    this.showValue = this.show
  },

  methods: {
    ...mapActions(useUserStore, { login: 'login' }),
    onForget() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'login', to: POPUP.RESET_PASSWORD, show: true })
    },
    onLogin() {
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 0
      })
      this.login(this.country, this.username, this.password).then((r) => {
        if (r.status === 1) {
          // this.username = ''
          // this.password = ''
          showSuccessToast({
            message: this.$t('login.success'),
            wordBreak: 'break-word',
            onClose: () => {
              closeToast()
              this.$bus.$emit(BUS.SHOW_POPUP, { from: 'login', to: POPUP.LOGIN, show: false })
            },
            duration: 3000
          })
          airbrideg_report(AIRBRIDEG_EVENT.SIGNIN)
          SocketService.emit('login', useUserStore().token)
          removeLocalStorage('invite')
        }
      })
    },
    onOpenRegister() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'login', to: POPUP.REGISTER, show: true })
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #f1f1f1;
  // background-image: linear-gradient(#000, #000),
  //   linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  // background-origin: border-box;
  // background-clip: content-box, border-box;
  text-align: center;
  z-index: 100;

  .popup {
    width: 81%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 0 5%;
    margin: 0 auto;
    font-size: 0.24rem;

    .banner {
      width: 5.4rem;
      height: 1.29rem;
      margin-top: 0rem;
      border-radius: 0.2rem;
      margin-bottom: 0.39rem;
    }

    h1 {
      font-size: 0.38rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #000;
    }

    .forget {
      display: flex;
      justify-content: flex-end;
      // margin-bottom: 0.2rem;
      width: 92%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #517ab8;
      text-decoration-line: underline;
      cursor: pointer;
      text-align: right;
    }

    .submit {
      width: 100%;
      height: var(--input-height);
      border-radius: 0.16rem;
      background: #336aea;
      line-height: var(--input-height);
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffffff;
      text-align: center;
      margin-top: 0.2rem;

      &:active {
        background: #98aa4a;
      }
    }

    .sign-up {
      display: flex;
      justify-content: center;
      margin: 0.36rem 0;
      width: 100%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #9ca0ab;
      text-align: center;

      span {
        color: #517ab8 !important;
      }
    }

    .popup_footer {
      text-align: center;
      margin: 0.3rem 0 0.3rem 0;
      // padding: 1.4rem 0 0;
      height: auto;
      width: 100%;
      color: #517ab8;
      font-size: 0.28rem;

      overflow: hidden;
      text-decoration: underline;
    }
  }

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    top: 0.5rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    right: 0rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }
}
</style>
